import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logAskAllTrailsViewedParams = {
  entry_point?: CardLocation;
  session_id?: string;
};

/**
 * User opens the Ask AllTrails experience.
 * @param params - Attributes to log with the amplitude event
 * @param params.entry_point - Surface where the user entered Ask AllTrails.
 * @param params.session_id - Unique id for a continuous Ask AllTrails session.
 */
const logAskAllTrailsViewed = ({ entry_point, session_id }: logAskAllTrailsViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('ask all trails viewed', { 'entry point': entry_point, 'session id': session_id }, callback);
};

export default logAskAllTrailsViewed;
